import React from "react";
import styled from "styled-components";
import {
  Bus,
  Cake,
  Church,
  Glasses,
  Camera,
  Utensils,
  Music2,
  Sandwich
} from "lucide-react";
import back from "./assets/hintergrundbild_ohne.png";

const timeline = [
  {
    time: "ca. 13:30",
    title: "Abfahrt in Yerevan",
    description:
      "Alle Gäste werden mit Bussen im Zentrum von Yerevan abgeholt und direkt zur Kirche gebracht. Der genaue Treffpunkt wird noch bekannt gegeben. Bitte erscheint pünktlich und plant mögliche Verkehrsverzögerungen ein.",
    icon: <Bus className="w-8 h-8 text-black" />
  },
  {
    time: "14:45",
    title: "Kirchliche Trauung",
    description:
      "Die Trauung beginnt um 15.00 Uhr. Die Gäste sollen bereits vorher in die Kirche eintreten und Platz nehmen.",
    icon: <Church className="w-8 h-8 text-black" />
  },
  {
    time: "ca. 15:30",
    title: "Fotos",
    description:
      "Nach der kirchlichen Trauung machen wir in der Nähe der Kirche erste Fotos. Da die Zeit für das Ehepaar sehr knapp ist, werden hier nicht gross Gruppenfotos gemacht. Wir bitten Euch um Verständnis und Geduld, am Abend gibts dann Möglichkeiten für Fotos :)",
    icon: <Camera className="w-8 h-8 text-black" />
  },
  {
    time: "16:30",
    title: "Abfahrt Richtung Restaurant",
    description:
      "Die Fahrt von der Kirche zum Restaurant ist ebenfalls organisiert. Wir treffen um ca. 17 Uhr ein.",
    icon: <Utensils className="w-8 h-8 text-black" />
  },
  {
    time: "17:30",
    title: "Eröffnung im Restaurant",
    description:
      "Der Abend wird durch unseren Tamada (Hochzeitsmoderator) offiziell eröffnet!",
    icon: <Music2 className="w-8 h-8 text-black" />
  },
  {
    time: "22:00",
    title: "Kuchen & Fotos",
    description:
      "Der Hochzeitkuchen wird im Garten angeschnitten – ein schöner Moment für Fotos und Erinnerungen.",
    icon: <Cake className="w-8 h-8 text-black" />
  },
  {
    time: "00:00",
    title: "Rückfahrt nach Yerevan",
    description:
      "Spätestens um Mitternacht verlassen wir das Restaurant. Die Rückfahrt nach Yerevan ist ebenfalls mit den Bussen organisiert.",
    icon: <Bus className="w-8 h-8 text-black" />
  }
];

const AblaufSeite = () => {
  return (
    <PageContainer>
      <Background />
      <MainContent>
        <Title>TAGESABLAUF</Title>
        <DateText>Hochzeitstag - 2. August 2025</DateText>
        <TimelineContainer>
          {timeline.map((event, index) => (
            <EventBlock key={index} reverse={index % 2 === 1}>
              {index % 2 === 0 ? (
                <>
                  <LeftText>
                    <EventTime>{event.time}</EventTime>
                    <EventTitle>{event.title.toUpperCase()}</EventTitle>
                    <EventDescription>{event.description}</EventDescription>
                  </LeftText>
                  <IconColumn>
                    <IconAligner>
                      <IconBox>{event.icon}</IconBox>
                    </IconAligner>
                    {index < timeline.length - 1 && <VerticalLine />}
                  </IconColumn>
                  <RightText />
                </>
              ) : (
                <>
                  <LeftText />
                  <IconColumn>
                    <IconAligner>
                      <IconBox>{event.icon}</IconBox>
                    </IconAligner>
                    {index < timeline.length - 1 && <VerticalLine />}
                  </IconColumn>
                  <RightText>
                    <EventTime>{event.time}</EventTime>
                    <EventTitle>{event.title.toUpperCase()}</EventTitle>
                    <EventDescription>{event.description}</EventDescription>
                  </RightText>
                </>
              )}
            </EventBlock>
          ))}
        </TimelineContainer>
        <Footer>
          <p>Wir freuen uns sehr auf diesen unvergesslichen Tag mit Euch!</p>
          <Highlight>Oliver & Gohar</Highlight>
        </Footer>
      </MainContent>
    </PageContainer>
  );
};

export default AblaufSeite;


const PageContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
`;

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${back}) no-repeat center center;
  background-size: cover;
  opacity: 0.9;
  z-index: -1;
`;

const MainContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 80px 20px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 4rem;
  color: #b79d66;
  font-family: serif;
  margin-bottom: 10px;
  letter-spacing: 2px;
`;

const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const EventBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  text-align: left;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const LeftText = styled.div`
  margin-top: -15px;
  text-align: right;
  padding-right: 10px;
  vertical-align: top;
  @media (max-width: 768px) {
    text-align: center;
    padding: 0;
  }
`;

const RightText = styled.div`
  margin-top: -15px;
  text-align: left;
  padding-left: 10px;
  vertical-align: top;
  @media (max-width: 768px) {
    text-align: center;
    padding: 0;
  }
`;

const EventTime = styled.p`
  font-weight: 600;
  color: #b79d66;
  margin-bottom: 0px !important;

`;

const EventTitle = styled.p`
  font-weight: 600;
  margin-top: 4px !important;
  margin-bottom: 0px !important;


`;

const EventDescription = styled.p`
  font-size: 18px;
  color: #555;
`;

const IconColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const IconAligner = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
`;

const IconBox = styled.div`
  width: 64px;
  height: 64px;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;

const VerticalLine = styled.div`
  width: 1px;
  height: 60px;
  background-color: #ccc;
  margin-top: 10px;
`;

const Footer = styled.div`
  margin-top: 80px;
  border-top: 1px solid #ddd;
  padding-top: 20px;
  text-align: center;
`;

const Highlight = styled.p`
  font-family: serif;
  font-weight: bold;
  color: #b79d66;
`;

const DateText = styled.p`
  font-size: 18px;
  margin-bottom: 80px;
  color:#b79d66;
`;
